export const ANONYMOUS_USER_AGENT = "anonymous";
const GFWEB_PRODUCT = "GfWeb";
export const GFWEB_VERSION = "3.15.15";
const GFWEB_USER_AGENT = `${GFWEB_PRODUCT}/${GFWEB_VERSION}`;

/**
 * 사용자 에이전트 값을 변환하는 함수
 * @param userAgentOriginal 원본 User-Agent 문자열
 * @returns 변환된 User-Agent 문자열
 */
export function transformUserAgent(
  userAgentOriginal = ANONYMOUS_USER_AGENT
): string {
  return `${GFWEB_USER_AGENT} (${userAgentOriginal})`;
}
